import { query } from '../../../../muster-react/src';
import linkSchema from './link.schema';
import Link from './link';

export default query(linkSchema)(Link);

